import { groupByKey } from ".";

export default function getItemsForGroupableSelects( items, itemGroupKey ) {
	const itemGroups = groupByKey( items, itemGroupKey );
	const groupNames = Object.keys( itemGroups );
	const selectItems = [];

	groupNames.sort();

	groupNames.forEach( ( groupName, index ) => {
		const isLastGroup = index === groupNames.length - 1;
		const groupItems = itemGroups[groupName];

		selectItems.push(
			{ header: groupName },
			...groupItems
		);

		if ( !isLastGroup ) {
			selectItems.push( { divider: true } );
		}
	} );

	return selectItems;
}
